import constants from '../constants/actions';

const initialState = {
    paymentModes: {},
    submodesFee: {}
};

const getPreparedData = (modes, flag, mode) => {
    const { amount, paymentModes, ...rest } = modes;
    const [data = {}] = paymentModes.filter(obj => obj['mode'] === mode);
    const { walletDed = 0, currModeDed = 0, currModeDedSnap = 0, walletDedSnap = 0, ...leftData } = data;

    const foundIndex = paymentModes.findIndex(x => x.mode === mode);
    paymentModes[foundIndex] = flag ?
        { ...leftData, mode, walletDed: walletDedSnap, currModeDed: currModeDedSnap, currModeDedSnap, walletDedSnap }
        :
        { ...leftData, mode, walletDed: 0, currModeDed: amount, currModeDedSnap, walletDedSnap };

    return { paymentModes, amount, ...rest };
};

export default function paymentReducer(state = initialState, action) {
    try {
        const { type = '', payload = [] } = action;
        switch (type) {
            case constants.PAYMENT.GET_PAYMENT_DATA: {
                return {
                    ...state,
                    paymentModes: payload
                };
            }
            case constants.PAYMENT.EMPTY_PAY_MODES: {
                return {
                    ...state,
                    paymentModes: payload
                };
            }
            case constants.PAYMENT.PAY_MODES_CHANGED: {
                const { flag = false, mode = '' } = payload;
                const prepareData = getPreparedData(state.paymentModes, flag, mode);
                return {
                    ...state,
                    paymentModes: prepareData
                };
            }
            case constants.PAYMENT.SET_PAYMENT_FEE: {
                return {
                    ...state,
                    submodesFee: payload
                };
            }
            default:
                return state;
        }

    } catch (error) {
        console.log('paymentReducer Try catch Error ', error);
        return state;
    }
}
